// extracted by mini-css-extract-plugin
var _1 = "DefaultSettings__defaults--nmiVO";
var _2 = "DefaultSettings__edit--kRGKy";
var _3 = "DefaultSettings__info--SfG_E";
var _4 = "DefaultSettings__item--U02tO";
var _5 = "DefaultSettings__itemLabel--GxPnU";
var _6 = "DefaultSettings__itemTop--NJBCx";
var _7 = "DefaultSettings__labelOnly--lqMFi";
var _8 = "DefaultSettings__main--k4Yty";
var _9 = "DefaultSettings__settingEditable--D8AsL";
var _a = "DefaultSettings__settingLabel--GDBuO";
export { _1 as "defaults", _2 as "edit", _3 as "info", _4 as "item", _5 as "itemLabel", _6 as "itemTop", _7 as "labelOnly", _8 as "main", _9 as "settingEditable", _a as "settingLabel" }
